// extracted by mini-css-extract-plugin
module.exports = {"relativo":"Fotos__relativo__32xHH","fondo_cuadricula1":"Fotos__fondo_cuadricula1__FCLtr","at_grid":"Fotos__at_grid__1pbnd"};